import { render } from "./BalIcon.vue?vue&type=template&id=2784720a"
import script from "./BalIcon.vue?vue&type=script&lang=ts"
export * from "./BalIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script